import { ArrowRight } from "lucide-react";
import { WHATSAPP_URL } from "../../lib/site";

const STEPS = [
    {
        title: "Primeiro contato",
        body: "Você envia uma mensagem no WhatsApp. Conversamos brevemente sobre o que está procurando e alinhamos horário, valor e modalidade.",
    },
    {
        title: "Sessão inicial",
        body: "Um encontro de escuta cuidadosa. Aqui entendemos juntos o que você traz e desenhamos um caminho terapêutico que faça sentido para a sua vida.",
    },
    {
        title: "Plano clínico",
        body: "Definimos frequência (semanal ou quinzenal), objetivos e ferramentas. O processo é construído com você — não para você.",
    },
    {
        title: "Caminho contínuo",
        body: "Sessões regulares, avaliação periódica e ajustes ao longo do percurso. Um espaço seguro para crescer no seu ritmo.",
    },
];

export const Process = () => {
    return (
        <section id="processo" data-testid="process-section" className="py-24 lg:py-32 relative">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
                <div className="lg:col-span-5 lg:sticky lg:top-32 lg:self-start reveal">
                    <p className="overline mb-5">Processo terapêutico</p>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.08] text-[#2F2F2F]">
                        Começar é mais simples
                        <span className="italic text-[#9f1e1e]"> do que parece.</span>
                    </h2>
                    <p className="mt-8 text-base leading-relaxed text-[#2F2F2F]/80 max-w-md">
                        O primeiro passo costuma ser o mais difícil — mas é também o mais transformador.
                        Aqui está como funciona, com transparência e leveza.
                    </p>
                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="process-cta"
                        className="btn-primary mt-10"
                    >
                        Dar o primeiro passo
                        <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
                    </a>
                </div>

                <div className="lg:col-span-7">
                    <ol className="relative">
                        {STEPS.map((step, i) => (
                            <li
                                key={step.title}
                                className="relative pl-12 lg:pl-16 pb-12 last:pb-0 reveal"
                                data-testid={`process-step-${i}`}
                            >
                                <span className="absolute left-0 top-1 font-display text-[#9f1e1e] text-3xl leading-none">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <span
                                    aria-hidden
                                    className="absolute left-3 top-12 bottom-0 w-px bg-[#B7A6B0]/60 last:hidden"
                                />
                                <h3 className="font-display text-2xl lg:text-3xl text-[#2F2F2F] leading-tight">
                                    {step.title}
                                </h3>
                                <p className="mt-4 text-[15px] leading-relaxed text-[#2F2F2F]/75 max-w-xl">
                                    {step.body}
                                </p>
                            </li>
                        ))}
                    </ol>
                </div>
            </div>
        </section>
    );
};
